import permissions from "app/permissions";
import { EmployeeServicePath, REQUESTS_HISTORY } from "utils/constants";
import RequestsHistoryList from "./List";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

export const resources = {
  isMenu: true,
  icon: <TaskAltIcon />,
  name: EmployeeServicePath + REQUESTS_HISTORY,
  title: "История на заявки",
  list: <RequestsHistoryList />,
  permission: [
    permissions.canPreviewStaffRequests,
    permissions.canSeeOthersStaffRequests
  ],
};
